var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.113,
    viewBox: "0 0 15 15.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6665",
    "data-name": "Group 6665",
    transform: "translate(4370 10103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6657",
    "data-name": "Group 6657",
    transform: "translate(2067 -717)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 15,
    height: 15,
    transform: "translate(-6437 -9386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Notification-Bell",
    transform: "translate(-4368 -10103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_439",
    "data-name": "Path 439",
    transform: "translate(4.367)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4,0A1.33,1.33,0,0,1,2.8,1.245,1.33,1.33,0,0,1,1.4,2.49,1.33,1.33,0,0,1,0,1.245,1.33,1.33,0,0,1,1.4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.4007169008255 0.749998927116394 C 1.04798686504364 0.749998927116394 0.7499969005584717 0.9766089916229248 0.7499969005584717 1.244848966598511 C 0.7499969005584717 1.513088941574097 1.04798686504364 1.739698886871338 1.4007169008255 1.739698886871338 C 1.753446936607361 1.739698886871338 2.051436901092529 1.513088941574097 2.051436901092529 1.244848966598511 C 2.051436901092529 0.9766089916229248 1.753446936607361 0.749998927116394 1.4007169008255 0.749998927116394 M 1.4007169008255 -9.5367431640625e-07 C 2.174306869506836 -9.5367431640625e-07 2.801436901092529 0.5573389530181885 2.801436901092529 1.244848966598511 C 2.801436901092529 1.932358980178833 2.174306869506836 2.489698886871338 1.4007169008255 2.489698886871338 C 0.627126932144165 2.489698886871338 -3.099441528320312e-06 1.932358980178833 -3.099441528320312e-06 1.244848966598511 C -3.099441528320312e-06 0.5573389530181885 0.627126932144165 -9.5367431640625e-07 1.4007169008255 -9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#ffa539"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M21.427,51.22a2.05,2.05,0,0,1-1.788,1.712A2.05,2.05,0,0,1,17.85,51.22",
    transform: "translate(-13.907 -38.193)",
    fill: "none",
    stroke: "#ffa539",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(0 2.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M243.273,266.443",
    transform: "translate(-239.104 -260.29)",
    fill: "none",
    stroke: "#8ac8d5",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M19.458.065c-1.565,0-2.9,1.918-2.9,3.762S14.223,8.6,14.223,8.6a2.142,2.142,0,0,0-.268,1.1c.024.623.142,1.164.95,1.173h9.569",
    transform: "translate(-13.954 -0.065)",
    fill: "none",
    stroke: "#14a4c2",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M18.969.065c1.565,0,2.9,1.918,2.9,3.762S24.2,8.6,24.2,8.6a2.142,2.142,0,0,1,.268,1.1c-.024.623-.142,1.164-.95,1.173H13.954",
    transform: "translate(-13.01 -0.065)",
    fill: "none",
    stroke: "#14a4c2",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M746.129,2783.848h.578",
    transform: "translate(-740.686 -2781.625)",
    fill: "none",
    stroke: "#14a4c2",
    strokeWidth: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/Notification-Bell.41a465de24758734f51456c5c6178905.svg";
export { ForwardRef as ReactComponent };